<!-- <ion-header>
  <top-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></top-nav-component>
</ion-header> -->

<ion-content>
  
  <!-- <page-loader-comp *ngIf="!longLoading && !mapLoaded"></page-loader-comp>

  <bloc-header-comp [compOptions]="{'title': blocHeaderTitle, mobile: false, loading: !mapLoaded}"></bloc-header-comp> -->

  <div class="gmap-container gmap-new" [ngClass]="{'with-cnil': !hideCnil}">
    <div class="geolocation-form" [ngClass]="{'with-results': showResults}">
      <div class="form-container">
        <h4>Des leçons près de chez toi</h4>
        <form>
          <input id="userInput" type="text" name="userInput" placeholder="Indiquer un lieu*" autocomplete="off" data-lpignore="true" (focus)="showResultsFullCards = false;" [ngClass]="{'with-delete-btn': placeLocationsSent}">
          <!-- <div class="geoloc-btn" (click)="showCurrentLocation()" [ngClass]="{'with-delete-btn': placeLocationsSent}">
            <img *ngIf="!geolocationLoading" src="assets/svg/geolocation.svg" alt="EnvoitureSimone">
            <span *ngIf="geolocationLoading">
              <ion-spinner class="btn-spinner" name="lines-small"></ion-spinner>
            </span>
          </div> -->
          <!-- <button class="btn" (click)="geoCoding()">GO</button> -->
          <div *ngIf="placeLocationsSent" class="delete-btn small-clickable" (click)="resetInput()"><img src="assets/svg/cross.svg" alt="EnvoitureSimone"></div>
        </form>
      </div>
      <div class="toggle-container">
        <div class="toggle-header">Type de boîte de vitesse</div>

        <div class="switch-wrapper">
          <div class="switch-selector" [ngClass]="{'manual-selected': switchOffers === 'BVM', 'automatic-selected': switchOffers === 'BVA', 'all-selected': switchOffers === 'ALL'}"></div>
          <button [ngClass]="{'selected-offer-type': switchOffers === 'BVM'}" (click)="setOffersDisplay('BVM')">Boîte manuelle</button>
          <button [ngClass]="{'selected-offer-type': switchOffers === 'BVA'}" (click)="setOffersDisplay('BVA')">Boîte auto</button>
          <button [ngClass]="{'selected-offer-type': switchOffers === 'ALL'}" (click)="setOffersDisplay('ALL')">Tous</button>
        </div>
      </div>
      <div id="results-desktop" class="results-desktop" [ngClass]="{'show': showResults}" #resultsDesktop>
        <div *ngFor="let result of dispoResults; let i = index" class="card-result">
          <div class="header" (click)="centerCardLocationOnMap(i)">
            <div class="icon" [ngClass]="{'gray-pin': !result.active}">
              <img src="https://app.envoituresimone.com/assets/png/pin-active.png" alt="EnvoitureSimone">
            </div>
            <div class="infos">
              <div *ngIf="!!result.address" class="street-name">{{result.address}}</div>
              <div *ngIf="!!result.distance" class="distance">{{result.distance}}</div>
            </div>
          </div>
          <div class="controls">
            <div class="item small-clickable" [ngClass]="{'active': result.itemActive === 'horaires'}" (click)="setActiveItem(i, 'horaires')">Horaires</div>
            <div class="item small-clickable" [ngClass]="{'active': result.itemActive === 'enseignants'}" (click)="setActiveItem(i, 'enseignants')">Enseignants</div>
          </div>
          <div *ngIf="result.itemActive === 'horaires'" class="horaires-container">
            <ul *ngIf="result.horaires.length > 0">
              <li *ngFor="let horaire of result.horaires">
                <span class="day">{{horaire.day}}</span>
                <span class="horaire">{{horaire.horaire}}</span>
              </li>
            </ul>
            <div *ngIf="result.horaires.length === 0" class="no-horaires">Aucune disponibilité pour le moment</div>
          </div>
          <div *ngIf="result.itemActive === 'enseignants' && result.teachers.length > 0" class="teachers-container" [ngClass]="{'two-columns': result.teachers.length > 4}">
            <div class="teacher" *ngFor="let teacher of result.teachers">
              <div class="teacher-infos">
                <div class="avatar" [ngStyle]="{'background-image': 'url(' + teacher.image + ')'}"></div>
                <div class="avatar-infos">
                  <div class="name">{{teacher.name}}</div>
                  <div class="car-model">
                    {{teacher.carModel}}
                    <span class="separator"> · </span>
                    <span class="manual" *ngIf="teacher.gearboxType === 'BVM'">Boîte manuelle</span>
                    <span class="automatic" *ngIf="teacher.gearboxType === 'BVA'">Boîte automatique</span>
                  </div>
                </div>
              </div>
              <div class="teacher-notes">
                <div class="stars" *ngIf="teacher.notes >= 50">
                  <div class="star" *ngFor="let i of utils.numberToArray(5)" [ngClass]="{'full-star': teacher.note >= (i+1), 'empty-star': teacher.note < (i+1), 'mid-star': (teacher.note > i && teacher.note < (i+1))}"></div>
                </div>
                <div class="note" *ngIf="teacher.notes >= 50">{{teacher.notes}} notes</div>
              </div>
              <div class="new-teacher" *ngIf="teacher.notes < 50">Nouveau</div>
            </div>
            <div class="notes"></div>
          </div>
          <div *ngIf="result.itemActive === 'enseignants' && result.teachers.length === 0" class="teachers-container" [ngClass]="{'two-columns': result.teachers.length > 4}">
            <div class="no-teacher">Aucun enseignant disponible</div>
          </div>
          <div class="btn-permis">
            <button class="btn full-width clickable" (click)="openLink('packPermisUrl', {gearboxTypeOnLocation: result.gearboxTypeOnLocation})">Passer le permis</button>
          </div>
        </div>
      </div>
    </div>
    <div #gMap class="gmap" [ngClass]="{'browser': !isCordova}"></div>
    <div class="evs-card-ui toaster-invalid-address" [ngClass]="{'show': addressInvalid}">
      <div class="no-entry-icon"><img src="assets/svg/no-entry.svg" alt="EnvoitureSimone"></div>
      <div class="invalid-address-text">
        <h3>Adresse invalide</h3>
        <div>{{userAddress}}</div>
      </div>
    </div>
    <div class="results-mobile" [ngClass]="{'display-none': dispoResults.length === 0, 'show': showResults}">
      <div id="slider" class="slider" [ngStyle]="{'width': ((dispoResults.length * 280) + ((dispoResults.length - 1) * 12) + 24) + 'px'}" #sliderResults>
        <div *ngFor="let result of dispoResults; let i = index" class="card-result" [ngClass]="{'reduced': !showResultsFullCards}">
          <div class="reduce-btn" (click)="switchCardReduction()"><hr></div>
          <div class="header" (click)="centerCardLocationOnMap(i)">
            <div class="icon" [ngClass]="{'gray-pin': !result.active}">
              <img src="https://app.envoituresimone.com/assets/png/pin-active.png" alt="EnvoitureSimone">
            </div>
            <div class="infos">
              <div *ngIf="!!result.address" class="street-name ellipsis">{{result.address}}</div>
              <div *ngIf="!!result.distance" class="distance">{{result.distance}}</div>
            </div>
          </div>
          <div class="elements-to-hide">
            <div class="controls">
              <div class="item small-clickable" [ngClass]="{'active': result.itemActive === 'horaires'}" (click)="setActiveItem(i, 'horaires')">Horaires</div>
              <div class="item small-clickable" [ngClass]="{'active': result.itemActive === 'enseignants'}" (click)="setActiveItem(i, 'enseignants')">Enseignants</div>
            </div>
            <div *ngIf="result.itemActive === 'horaires'" class="horaires-container">
              <ul *ngIf="result.horaires.length > 0">
                <li *ngFor="let horaire of result.horaires">
                  <span class="day">{{horaire.day}}</span>
                  <span class="horaire">{{horaire.horaire}}</span>
                </li>
              </ul>
              <div *ngIf="result.horaires.length === 0" class="no-horaires">Aucune disponibilité pour le moment</div>
            </div>
            <div *ngIf="result.itemActive === 'enseignants' && result.teachers.length > 0" class="teachers-container" [ngClass]="{'two-columns': result.teachers.length > 4}">
              <div class="teacher" *ngFor="let teacher of result.teachers">
                <div class="teacher-infos">
                  <div class="avatar" [ngStyle]="{'background-image': 'url(' + teacher.image + ')'}"></div>
                  <div class="avatar-infos">
                    <div class="name">{{teacher.name}}</div>
                    <div class="car-model">
                      {{teacher.carModel}}
                      <br>
                      <span class="manual" *ngIf="teacher.gearboxType === 'BVM'">Boîte manuelle</span>
                      <span class="automatic" *ngIf="teacher.gearboxType === 'BVA'">Boîte automatique</span>
                    </div>
                    <div class="stars" *ngIf="result.teachers.length > 4">
                      <div class="star" *ngFor="let i of utils.numberToArray(5)" [ngClass]="{'full-star': teacher.note >= (i+1), 'empty-star': teacher.note < (i+1), 'mid-star': (teacher.note > i && teacher.note < (i+1))}"></div>
                    </div>
                  </div>
                </div>
                <div class="teacher-notes">
                  <div class="stars" *ngIf="teacher.notes >= 50">
                    <div class="star" *ngFor="let i of utils.numberToArray(5)" [ngClass]="{'full-star': teacher.note >= (i+1), 'empty-star': teacher.note < (i+1), 'mid-star': (teacher.note > i && teacher.note < (i+1))}"></div>
                  </div>
                  <div class="note" *ngIf="teacher.notes >= 50">{{teacher.notes}} notes</div>
                </div>
                <div class="new-teacher" *ngIf="teacher.notes < 50">Nouveau</div>
              </div>
            </div>
            <div *ngIf="result.itemActive === 'enseignants' && result.teachers.length === 0" class="teachers-container">
              <div class="no-teacher">Aucun enseignant disponible</div>
            </div>
          </div>
          <div class="btn-permis" [ngClass]="{'margin-top-4': result.itemActive === 'enseignants' && result.teachers.length > 1 && showResultsFullCards}">
            <button class="btn full-width clickable" (click)="openLink('packPermisUrl', {gearboxTypeOnLocation: result.gearboxTypeOnLocation})">Passer le permis</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="cnil small-text" [ngClass]="{'display-none': hideCnil}">
    <p>Les champs portant une * sont obligatoires et font l’objet d’un traitement par En Voiture Simone dans le cadre de son service. Les données que tu renseignes font l'objet d'un traitement de données à caractère personnel par la société EVS Auto-Ecole ("EVS").</p>
    <p>EVS traite tes données à caractère personnel pour :</p>
    <ul>
      <li>fournir les prestations commandés à partir de son site web et, le cas échéant</li>
      <li>te communiquer des newsletters</li>
      <li>pour t'adresser des sollicitations commerciales par courrier électronique ou par SMS</li>
      <li>te contacter après finalisation de ton inscription.</li>
    </ul>
    <p>Le caractère obligatoire de la saisie est indiqué grâce à un astérisque (*).</p>
    <p>Conformément à la loi 78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés modifiée, tu disposes d'un droit d'accès, de rectification, d'effacement ou d'opposition des informations collectées te concernant que tu peux exercer en nous écrivant selon les modalités prévues au sein de notre <a (click)="goConfidentialite()">Politique de Confidentialité.</a></p>
  </div>

  <modal-comp [compOptions]="{'id': 'customModalNoResults', size: 'small'}" *ngIf="modalNoResults" (canClose)="hideModalNoResults()">
    <div class="text-center">
      <p>Zut, il n’y a pas encore de point de rendez-vous près de chez toi…</p>
      <button class="btn full-width" (click)="resetInput()">Chercher une autre adresse</button>
    </div>
  </modal-comp>
  
  <modal-comp [compOptions]="{'id': 'customModalNoGeoloc', size: 'small'}" *ngIf="modalNoGeoloc" (canClose)="hideModalNoGeoloc()">
    <div class="text-center">
      <p>{{noGeolocText}}</p>
      <button class="btn full-width" (click)="hideModalNoGeoloc()">J'ai compris</button>
    </div>
  </modal-comp>
  
  <modal-comp [compOptions]="{'id': 'customModalLocationError'}" *ngIf="modalLocationError" (canClose)="hideModalLocationError()">
    <div class="text-center">
      <h3>Une erreur est survenue</h3>
      <p>Nous ne sommes pas parvenus à récupérer nos points de rendez-vous. Réessaie plus tard.</p>
      <button class="btn full-width" (click)="hideModalLocationError()">J'ai compris</button>
    </div>
  </modal-comp>
  
  <modal-comp [compOptions]="{'id': 'customModalSearchError'}" *ngIf="modalSearchError" (canClose)="hideModalSearchError()">
    <div class="text-center">
      <h3>Une erreur est survenue</h3>
      <p>Nous ne sommes pas parvenus à traiter ta recherche. Réessaie plus tard.</p>
      <button class="btn full-width" (click)="hideModalSearchError()">J'ai compris</button>
    </div>
  </modal-comp>

</ion-content>

<!-- <ion-footer>
  <footer-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></footer-nav-component>
</ion-footer> -->